// extracted by mini-css-extract-plugin
export default {"logo":"---------packages-corgi-x-src-components-Logo-Logo-module__logo","path":"---------packages-corgi-x-src-components-Logo-Logo-module__path"};